import { useState, useEffect, useRef, MutableRefObject } from "react"

import {
  SelectValueContainer,
  SelectValueContainerText,
  SelectValueContainerCounter,
} from "./styles"

export const SelectValue = ({ children, id }: { children: any; id: string }) => {
  return (
    <SelectValueContainer id={id}>
      <SelectValueContainerText>{children}</SelectValueContainerText>
    </SelectValueContainer>
  )
}

export const SelectValues = ({
  children,
  id,
  count,
  isDisabled,
}: {
  id: string
  children: any
  count: number
  isDisabled: boolean
}) => {
  const refText: MutableRefObject<HTMLDivElement | null> = useRef(null)
  const refTextContainer: MutableRefObject<HTMLDivElement | null> = useRef(null)
  const refCounter: MutableRefObject<HTMLDivElement | null> = useRef(null)

  const [widthText, setWidthText] = useState(0)
  const [widthCounter, setWidthCounter] = useState(0)
  const [widthTextContainer, setWidthTextContainer] = useState(100)

  useEffect(() => {
    return () => {
      refText.current && setWidthText(refText.current.offsetWidth)
      refTextContainer.current &&
        setWidthTextContainer(refTextContainer.current.offsetWidth)
      refCounter.current && setWidthCounter(refCounter.current.offsetWidth)
    }
  })

  return (
    <SelectValueContainer id={id} ref={refTextContainer}>
      <SelectValueContainerText ref={refText} isDisabled={isDisabled}>
        {children}
      </SelectValueContainerText>
      <SelectValueContainerCounter
        ref={refCounter}
        isVisible={widthTextContainer - widthText - widthCounter <= 10}
      >
        ({count})
      </SelectValueContainerCounter>
    </SelectValueContainer>
  )
}
